import React from 'react';
import { Dialog, Stack } from '@mui/material';
import styles from '../../../../custom/style.module.css';
import {
  CustomDialogTitle,
  CustomDialogContent,
} from '../../../../custom/components';
import { CloseIconBtn } from '../../../../custom/constants';
import FwbDiffViewer from './FwbDiffViewer';

const FwbDiffModal = ({
  open = false,
  onClose,
  oldText = '',
  newText = '',
  onAccept,
  onReject,
  acceptButtonRef,
}) => {
  if (!open) return null;

  return (
    <Dialog
      aria-labelledby='fwb-diff-dialog-title'
      open={open}
      onClose={onClose}
      maxWidth='lg'
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: '12px',
            overflow: 'hidden',
          },
        },
      }}
    >
      <CustomDialogTitle id='fwb-diff-dialog-title' className={styles.modalTitle}>
        <Stack direction='row' alignItems='center' justifyContent='space-between' width='100%'>
          <span>Review FWB Changes</span>
          <CloseIconBtn onClick={onClose} />
        </Stack>
      </CustomDialogTitle>
      <CustomDialogContent className={styles.p2}>
        <FwbDiffViewer
          oldText={oldText}
          newText={newText}
          status='pending'
          sideBySide={true}
          showViewToggle={true}
          onAccept={onAccept}
          onReject={onReject}
          acceptButtonRef={acceptButtonRef}
        />
      </CustomDialogContent>
    </Dialog>
  );
};

export default FwbDiffModal;
